import { render, staticRenderFns } from "./InProgressTable.vue?vue&type=template&id=36a23690"
import script from "./InProgressTable.vue?vue&type=script&lang=js"
export * from "./InProgressTable.vue?vue&type=script&lang=js"
import style0 from "./InProgressTable.vue?vue&type=style&index=0&id=36a23690&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports